<template>
  <div class="game-buddy-time-slot-container">
    <el-card class="time-slot-card" shadow="hover">
      <div slot="header" class="clearfix">
        <span>设置可陪玩时间</span>
      </div>
      
      <el-button type="primary" size="small" @click="addTimeSlot" style="margin-bottom: 20px;">
        <i class="el-icon-plus"></i> 添加时间段
      </el-button>
      
      <el-table :data="timeSlots" border style="width: 100%">
        <el-table-column prop="dayOfWeek" label="星期几">
          <template slot-scope="scope">
            <el-select v-model="scope.row.dayOfWeek" placeholder="请选择">
              <el-option label="星期一" value="1"></el-option>
              <el-option label="星期二" value="2"></el-option>
              <el-option label="星期三" value="3"></el-option>
              <el-option label="星期四" value="4"></el-option>
              <el-option label="星期五" value="5"></el-option>
              <el-option label="星期六" value="6"></el-option>
              <el-option label="星期日" value="7"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="startTime" label="开始时间">
          <template slot-scope="scope">
            <el-time-picker 
              v-model="scope.row.startTime" 
              format="HH:mm" 
              placeholder="选择开始时间"
              style="width: 100%;"
            ></el-time-picker>
          </template>
        </el-table-column>
        <el-table-column prop="endTime" label="结束时间">
          <template slot-scope="scope">
            <el-time-picker 
              v-model="scope.row.endTime" 
              format="HH:mm" 
              placeholder="选择结束时间"
              style="width: 100%;"
            ></el-time-picker>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="danger" size="small" @click="deleteTimeSlot(scope.$index)">
              <i class="el-icon-delete"></i> 删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <div style="margin-top: 20px; text-align: right;">
        <el-button type="primary" @click="saveTimeSlots" :loading="loading">保存设置</el-button>
        <el-button @click="resetForm">重置</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>

export default {
  name: 'GameBuddyTimeSlot',
  data() {
    return {
      loading: false,
      timeSlots: [],
      gameBuddyId: null
    }
  },
  mounted() {
    // 初始化数据，获取当前陪玩选手的ID和已设置的时间
    this.initData()
  },
  methods: {
    initData() {
      // 从localStorage获取当前用户信息，这里假设已经是陪玩选手
      const user = JSON.parse(localStorage.getItem('user'))
      if (user) {
        // TODO: 根据用户ID获取陪玩选手ID
        // 这里简化处理，假设gameBuddyId直接从用户信息获取
        this.gameBuddyId = 1 // 实际应该从后端获取
        this.loadTimeSlots()
      }
    },
    loadTimeSlots() {
      if (this.gameBuddyId) {
        this.$axios.get(`/game-buddy/time-slot/list/${this.gameBuddyId}`)
          .then(response => {
            this.timeSlots = response.data.data || []
          })
          .catch(error => {
            this.$message.error('加载时间设置失败')
            console.error('Load time slots error:', error)
          })
      }
    },
    addTimeSlot() {
      this.timeSlots.push({
        id: null,
        gameBuddyId: this.gameBuddyId,
        dayOfWeek: '',
        startTime: '',
        endTime: ''
      })
    },
    deleteTimeSlot(index) {
      this.timeSlots.splice(index, 1)
    },
    saveTimeSlots() {
      // 验证所有时间槽都已填写完整
      const isValid = this.timeSlots.every(slot => {
        return slot.dayOfWeek && slot.startTime && slot.endTime
      })
      
      if (!isValid) {
        this.$message.error('请填写所有时间段的完整信息')
        return
      }
      
      this.loading = true
      this.$axios.post('/game-buddy/time-slot/save', this.timeSlots)
              .then(response => {
                this.$message.success('时间设置保存成功')
              })
              .catch(error => {
                this.$message.error('保存失败，请重试')
                console.error('Save time slots error:', error)
              })
              .finally(() => {
                this.loading = false
              })
    },
    resetForm() {
      this.loadTimeSlots()
    }
  }
}
</script>

<style scoped>
.game-buddy-time-slot-container {
  padding: 20px 0;
}

.time-slot-card {
  margin-bottom: 20px;
}
</style>
